// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ResponsiveImage_wrapper__mZ4Co"};